import { useCallback, useEffect, useState } from 'react'
import { Select } from 'antd'
import Cookies from 'js-cookie'
import { baseAxiosComplete } from '../tool/axios'
import defaultUserIcon from '../images/default_user_icon.png'
import UserData from '../js/userData'

const { Option } = Select
let timer: any = null

export default function HeaderUserMenu() {

    const [userData, setUserData] = useState<any>({ user_name: '', phone: '', position_list: [] })
    const [checkPositionVisbled, setCheckPositionVisbled] = useState<boolean>(false)
    const [positionName, setPositionName] = useState<string>('')

    useEffect(() => {
        let data: any = localStorage.getItem('userData')
        let d = JSON.parse(data)
        setUserData(d)

        let position = d.position_list.find((el: any) => el.position_id === d.current_position_id)
        position && setPositionName(position.position_name)
    }, [])

    const logOut = () => {
        baseAxiosComplete.post('/global/login_out', {
            out_type: 9999
        }).then((res: any) => {
            if (res.status === 0) {
                Cookies.set('token', '')
                window.location.reload()
            }
        })
    }

    const hide = useCallback(_ => {
        setCheckPositionVisbled(false)
    }, [])

    return <div id="header-user-menu" className="clear">
        <div className="fl">
            <img src={defaultUserIcon} style={{ width: 32 }} alt="" />
        </div>

        <div className="fl clear userinfo" style={{ margin: '0 10px' }} onMouseEnter={() => {
            clearTimeout(timer)
            setCheckPositionVisbled(true)
        }} onMouseLeave={() => {
            timer = setTimeout(hide, 300)
        }}>
            <span className="fl">{positionName || '管理员'}-</span>
            <span className="fl">{UserData.user_name}</span>
            <span className="arrow fl" style={{ marginTop: 20, marginLeft: 6 }}></span>

            {checkPositionVisbled && <Select style={{ width: 120 }} placeholder="选择职位" className="check-position" onChange={(v: string) => {
                baseAxiosComplete.post('/global/change_position', { position_id: v }).then((res: any) => {
                    if (res.status === 0) {
                        let data: any = localStorage.getItem('userData')
                        data = JSON.parse(data)

                        data.current_position_id = res.data.current_position_id
                        data.current_position_number = res.data.current_position_number
                        data.top_menu_list = res.data.top_menu_list
                        data.left_menu_list = res.data.left_menu_list
                        data.right_menu_list = res.data.right_menu_list

                        localStorage.setItem('userData', JSON.stringify(data))
                        window.location.pathname = ''
                    }
                })
            }}>
                {userData.position_list.map((el: { position_id: string, position_name: string }) => <Option key={el.position_id} value={el.position_id}>{el.position_name}</Option>)}
            </Select>}
        </div>

        <div className="fl"><a onClick={logOut}>退出</a></div>
    </div>
}